import { render, staticRenderFns } from "./publicNotes.vue?vue&type=template&id=0451a2d5&scoped=true&"
import script from "./publicNotes.vue?vue&type=script&lang=js&"
export * from "./publicNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0451a2d5",
  null
  
)

export default component.exports